export const LIST = 'CATEGORY/list';
export const PAGER = 'CATEGORY/pager';
export const ITEM = 'CATEGORY/item';
export const FILTER = 'CATEGORY/filter';
